import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NyxtLogo } from '../components/NyxtLogo';
import { Loader2 } from 'lucide-react';

// Logger utility
const logger = {
  error: (message, error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(message, error);
    }
  }
};

export const AuthCallback = () => {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const processAuth = useCallback(async () => {
    try {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        logger.error('No session_id found in URL', null);
        navigate('/');
        return;
      }
      
      const sessionId = sessionIdMatch[1];
      const userData = await exchangeSession(sessionId);
      navigate('/dashboard', { state: { user: userData } });
    } catch (error) {
      logger.error('Auth callback error:', error);
      navigate('/');
    }
  }, [exchangeSession, navigate]);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processAuth();
  }, [processAuth]);

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ backgroundColor: '#F9F8F6' }}
    >
      <NyxtLogo size={64} className="mb-6" />
      <Loader2 className="w-8 h-8 animate-spin mb-4" style={{ color: '#D97757' }} />
      <p style={{ color: '#596059' }}>Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
